import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cascader = _resolveComponent("van-cascader");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.show = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cascader, {
      modelValue: $data.cascaderValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.cascaderValue = $event),
      title: "请选择所在省市区",
      "field-names": $data.fieldNames,
      loading: $data.isLoading,
      options: $data.dataRes,
      onChange: $options.onChange,
      onFinish: $options.onConfirmClick,
      onClose: $options.onCancelClick
    }, null, 8, ["modelValue", "field-names", "loading", "options", "onChange", "onFinish", "onClose"])]),
    _: 1
  }, 8, ["show"]);
}